export default __webpack_public_path__ + "static/media/pagetwotop.f1a97d7b.png";